export default __webpack_public_path__ + "static/media/loadingLogo.b3bc11ee.svg";